'use client'

import SportPage from '@/components/organisms/sportPage'

const TennisBaliPage = ({ pageAPI, testimonials, tennisPricing, footerAPI, settingAPI }) => (
  <SportPage sport="TENNIS" pageAPI={pageAPI} testimonials={testimonials} pricing={tennisPricing?.tennis}
    footerAPI={footerAPI} settingAPI={settingAPI} />
)

export default TennisBaliPage
